<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Paramètres du compte
              </router-link>
            </li>

            

            <li>
              <router-link
                to="/settings-statuts"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Status
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-type-clients"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Types des clients
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-banks"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Liste des banques
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-social-links"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Social Link
              </router-link>
            </li>

            <!-- <li>
              <router-link
                to="/settings-privacy-policy"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Privacy Policy
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <form @submit.prevent="submitForm">
            <label class="d-block text-black fw-semibold mb-10"
              >Add Social Media Link</label
            >
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="input-group">
                    <span
                      class="input-group-text rounded-0 fs-14 fw-bold text-primary"
                    >
                      <i class="ph-bold ph-facebook-logo lh-1 fs-md-18"></i>
                    </span>
                    <input
                      type="text"
                      v-model="settingData.facebook"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="input-group">
                    <span
                      class="input-group-text rounded-0 fs-14 fw-bold text-primary"
                    >
                      <i class="ph-fill ph-twitter-logo lh-1 fs-md-18"></i>
                    </span>
                    <input
                      type="text"
                      v-model="settingData.twitter"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="input-group">
                    <span
                      class="input-group-text rounded-0 fs-14 fw-bold text-primary"
                    >
                      <i class="ph-bold ph-linkedin-logo lh-1 fs-md-18"></i>
                    </span>
                    <input
                      type="text"
                      v-model="settingData.linkedin"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="input-group">
                    <span
                      class="input-group-text rounded-0 fs-14 fw-bold text-primary"
                    >
                      <i class="ph-bold ph-instagram-logo lh-1 fs-md-18"></i>
                    </span>
                    <input
                      type="text"
                      v-model="settingData.instagram"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="input-group">
                    <span
                      class="input-group-text rounded-0 fs-14 fw-bold text-primary"
                    >
                      <i class="ph-bold ph-youtube-logo lh-1 fs-md-18"></i>
                    </span>
                    <input
                      type="text"
                      v-model="settingData.youtube"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="input-group">
                    <span
                      class="input-group-text rounded-0 fs-14 fw-bold text-primary"
                    >
                      <i class="ph-bold ph-snapchat-logo lh-1 fs-md-18"></i>
                    </span>
                    <input
                      type="text"
                      v-model="settingData.snapchat"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-sm-flex align-items-center justify-content-between">
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                Save Changes
              </button>
              <!-- <button
                type="button"
                class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium mt-15 mt-sm-0"
              >
                <i
                  class="flaticon-delete lh-1 me-1 position-relative top-2"
                ></i>
                <span class="position-relative">Cancel</span>
              </button> -->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import api from '@/utils/axios';
import { defineComponent, reactive, onMounted } from 'vue';
import { useAppToast } from "@/composables/useAppToast";

export default defineComponent({
  name: "SocialLinks",
  setup: () => {
    const { showToast } = useAppToast();
    const settingData = reactive<Record<string, any>>({})

 onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/Links_list`);
        Object.assign(settingData, response.data);
       
      } catch (error) {
        console.error("Error fetching user account:", error);
      }
     
    });
    async function submitForm() {
          try {
            const formData = new FormData();
            formData.append("facebook", settingData.facebook);
            formData.append("instagram", settingData.instagram);
            formData.append("youtube", settingData.youtube);
            formData.append("twitter", settingData.twitter);
            formData.append("linkedin", settingData.linkedin);
            formData.append("snapchat", settingData.snapchat);
    
            const response = await api.post("/api/auth/general_add", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
    
            if (response.data.success) {
              showToast("Settings saved successfully!", "success");
            } else {
              showToast("Error: " + response.data.message, "error");
            }
          } catch (error) {
            console.error(error);
            showToast("An error occurred while saving settings.", "error");
          }
        }
    return {
      settingData,
      submitForm
    };
  },
});
</script>